
import { status as submissionStatuses } from './data';

export class SubmissionUtils {
    private static readonly classifiedStatusValueMap: Record<string, string[]> = {
        BOUND: [
            'bound_and_inv',
            'reinstated',
            'bound',
            'nor_pending_reinstatement',
            'policy_issued'
        ],
        CLOSED: [
            'dnoc_pending_cancellation',
            'cancelled_policy',
            'ignore_error',
            'cancelled_application',
            'closed',
            // 'declined',
            'not_taken',
            'expired',
            'close_file_cannot_complete',
            'closed_file_not_a_opportunity_block'
        ],
        QUOTE: [
            'filings_requested',
            'released',
            'pending_quote',
            'indication_only',
            'approved',
            'quoted',
            'pending_bind'
        ],
        SUBMISSION: [
            'pending_uw_approval',
            'online_submission_received',
            'other_see_notes',
            'pending_submission',
            'mgmt_review_pending',
            'received',
            'uw_approval_pending',
            'uw_approved',
            'uw_review',
            'pending_telematics',
            'pending_information'
        ],
        DECLINE:[
            'declined'
        ]
    };

    static getClassifiedStatus(statusText: string): string {
        const status = statusText?.trim().toUpperCase();

        const boundStatuses = [
            'BOUND & INV',
            'REINSTATED',
            'BOUND',
            'NOR/PENDING REINSTATEMENT',
            'POLICY ISSUED'
        ];

        const closedStatuses = [
            'DNOC/PENDING CANCELLATION',
            'CANCELLED POLICY',
            'IGNORE/ERROR',
            'CANCELLED APPLICATION',
            'CLOSED',
            // 'DECLINED',
            'NOT TAKEN',
            'EXPIRED',
            'CLOSE FILE - CANNOT COMPETE',
            'CLOSE FILE - NOT AN OPPORTUNITY/BLOCK'
        ];

        const quoteStatuses = [
            'FILINGS REQUESTED',
            'RELEASED',
            'PENDING QUOTE',
            'INDICATION ONLY',
            'APPROVED',
            'QUOTED',
            'PENDING BIND'
        ];

        const submissionStatuses = [
            'PENDING UW APPROVAL',
            'ONLINE SUBMISSION RECEIVED',
            'OTHER - SEE NOTES',
            'PENDING SUBMISSION',
            'MGMT REVIEW PENDING',
            'RECEIVED',
            'UW APPROVAL PENDING',
            'UW APPROVED',
            'UW REVIEW',
            'PENDING TELEMATICS',
            'PENDING INFORMATION'
        ];
        const declineStatuses = [
            'DECLINED'
        ];

        if (boundStatuses.includes(status)) {
            return 'BOUND';
        }

        if (closedStatuses.includes(status)) {
            return 'CLOSED';
        }

        if (quoteStatuses.includes(status)) {
            return 'QUOTE';
        }

        if (submissionStatuses.includes(status)) {
            return 'SUBMISSION';
        }
         if (declineStatuses.includes(status)) {
            return 'DECLINE';
        }

        return 'NO MATCH';
    }

    static getStatusIdsForFilterInput(filterInput: string): number[] {
        const selectedGroups = filterInput
            .split(',')
            .map((value) => value.trim().toUpperCase())
            .filter((value) => value.length > 0);

        if (!selectedGroups.length) {
            return [];
        }

        const matchedStatusValues = new Set<string>();

        selectedGroups.forEach((group) => {
            const values = this.classifiedStatusValueMap[group];

            values?.forEach((value) => matchedStatusValues.add(value));
        });

        if (!matchedStatusValues.size) {
            return [];
        }

        return submissionStatuses
            .filter((item) => matchedStatusValues.has(item.value))
            .map((item) => item.sr);
    }

    static getLobType(lobType: number): string {
        switch (lobType) {
            case 485:
            case 495:
            case 499:
                return 'casualty'
            case 492:
                return "property"
            default:
                return 'property';
        }
    }
}
